<template>
  <div class="dark">
    <div class="logo"></div>
    <div class="welcome">
      <div class="big">Hi, 你好！</div>
      <div class="big">欢迎来到Bugu-farm</div>
      <div class="small">Welcome to Bugu-farm</div>
    </div>
    <div class="logo-form">
      <LoginForm />
    </div>
    <!--    <div class="logo-footer">-->
    <!--&lt;!&ndash;      <div>Copyright © 银都餐饮设备股份有限公司</div>&ndash;&gt;-->
    <!--      &lt;!&ndash;      <div>浙ICP备15015690号-1</div>&ndash;&gt;-->
    <!--    </div>-->
  </div>
</template>

<script>
import LoginForm from './LoginForm'
export default {
  components: {
    LoginForm
  }
}
</script>

<style lang="scss" scoped>
.dark {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 52px;
  background-image: url('../../assets/deep_login_bg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  .logo {
    margin-left: 140px;
    width: 160px;
    height: 40px;
    background-image: url('../../assets/deep_login_logo.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .welcome {
    position: absolute;
    top: 50%;
    left: 140px;
    margin-top: -214px;
    padding-top: 80px;
    height: 428px;
    width: max-content;
    .big {
      line-height: 72px;
      font-size: 64px;
      font-weight: 700;
      color: #ffffff;
    }
    .small {
      margin-top: 16px;
      line-height: 28px;
      font-size: 20px;
      font-weight: 400;
      color: #bac4d1;
    }
  }
  .logo-form {
    position: absolute;
    top: 50%;
    right: 140px;
    margin-top: -214px;
    width: 400px;
    height: 428px;
  }
  .logo-footer {
    position: absolute;
    left: 0;
    bottom: 48px;
    width: 100%;
    line-height: 22px;
    font-size: 14px;
    font-weight: 400;
    color: #bac4d1;
    text-align: center;
  }
}
</style>
